import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Dropdown from 'flarum/common/components/Dropdown';
import RenameTagModal from '../Modals/RenameTagModal';
import EditTagDescriptionModal from '../Modals/EditTagDescriptionModal';
import EditTagIconModal from '../Modals/EditTagIconModal';
import withLocaleKnowledgeBaseLink from '../../utils/withLocaleKnowledgeBaseLink';
import app from 'flarum/forum/app';

export default class EditArticleListDropdown extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    this.tag = this.attrs.currentTag;
    this.multiCategory = this.attrs.multiCategory || false;
    this.redirectAfterRename = this.attrs.redirectAfterRename || false;

    this.loading = false;
  }

  view() {
    let buttons = [];

    if (!this.attrs.noCreateArticle && (app.session.user.canEdit() || this.tag.canStartDiscussion())) {
      buttons.push(
        Button.component(
          {
            className: 'Button',
            onclick: () => this.newArticle(),
            icon: 'fas fa-plus',
          },
          app.translator.trans('v17development-flarum-support.forum.overview.tools.new_article')
        )
      );
    }

    // Rename tag
    if (app.forum.attribute('adminUrl')) {
      if (!this.attrs.noCreateArticle) {
        buttons.push(<li className="Dropdown-separator" />);
      }

      buttons.push(
        Button.component(
          {
            className: 'Button',
            disabled: this.loading,
            onclick: () =>
              app.modal.show(RenameTagModal, {
                currentTag: this.tag,
                isMulti: this.multiCategory,
                redirect: this.redirectAfterRename,
              }),
            icon: 'fas fa-pencil-alt',
          },
          app.translator.trans('v17development-flarum-support.forum.overview.tools.rename_category')
        )
      );

      buttons.push(
        Button.component(
          {
            className: 'Button',
            disabled: this.loading,
            onclick: () =>
              app.modal.show(EditTagDescriptionModal, {
                currentTag: this.tag,
              }),
            icon: 'fas fa-paragraph',
          },
          app.translator.trans('v17development-flarum-support.forum.overview.tools.edit_description')
        )
      );

      buttons.push(
        Button.component(
          {
            className: 'Button',
            disabled: this.loading,
            onclick: () =>
              app.modal.show(EditTagIconModal, {
                currentTag: this.tag,
              }),
            icon: 'fas fa-icons',
          },
          app.translator.trans('v17development-flarum-support.forum.overview.tools.change_icon')
        )
      );

      // Recount category
      buttons.push(
        Button.component(
          {
            className: 'Button',
            loading: this.loading,
            onclick: () => {
              this.loading = true;

              app.store
                .find('/support/tags/recount', this.tag.id())
                .then(() => m.redraw())
                .catch(() => {})
                .then(() => (this.loading = false));
            },
            icon: 'fas fa-sync',
          },
          app.translator.trans('v17development-flarum-support.forum.overview.tools.recount_articles')
        )
      );
    }

    // Update article SEO
    if ('v17development-seo' in flarum.extensions && app.forum.attribute('canConfigureSeo')) {
      const {
        components: { MetaSeoModal },
      } = require('@v17development-seo');

      buttons.push(
        Button.component(
          {
            className: 'Button',
            onclick: () =>
              app.modal.show(MetaSeoModal, {
                objectType: 'tags',
                objectId: this.tag.id(),
              }),
            icon: 'fas fa-search',
          },
          app.translator.trans('v17development-flarum-seo.forum.controls.configure_seo')
        )
      );
    }

    // Catch, the user has some kind of rights, but not enough
    if (buttons.length === 0) {
      return <div />;
    }

    const button = Dropdown.component(
      {
        icon: this.isSingleCategory ? 'fas fa-ellipsis-v' : 'fas fa-cog',
        buttonClassName: 'Button',
        menuClassName: 'Dropdown-menu--right',
      },
      buttons
    );

    // Button
    if (this.attrs.noContainer) {
      return button;
    }

    return <div className="Support-Settings-Holder">{button}</div>;
  }

  /**
   * New article
   */
  newArticle() {
    let tags = [];

    // Add mail tag
    if (this.tag.isChild()) {
      tags.push(this.tag.parent().slug());
    }

    tags.push(this.tag.slug());

    m.route.set(
      withLocaleKnowledgeBaseLink('knowledgeBaseComposer', {
        tags: tags.join(','),
      })
    );
  }
}
